import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from '../activeRecord'

class SeldonBeattieForm extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._employee_id = init.employee_id
    this._form_attachment = init.form_attachment
    this._patient_name = init.patient_name
    this._height = init.height
    this._weight = init.weight
    this._screen_date = init.screen_date
    this._body_mass_index = init.body_mass_index
    this._a1c = init.a1c
    this._blood_pressure = init.blood_pressure
    this._total_cholesterol = init.total_cholesterol
    this._ldl_cholesterol = init.ldl_cholesterol
    this._hdl_cholesterol = init.hdl_cholesterol
    this._triglycerides = init.triglycerides
    this._fasting_glucose = init.fasting_glucose
    this._smoking_attestation = init.smoking_attestation
  }

  static shape = {
    employee_id: PropTypes.string.isRequired,
    form_attachment: PropTypes.object,
    patient_name: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    weight: PropTypes.string.isRequired,
    screen_date: PropTypes.string.isRequired,
    body_mass_index: PropTypes.string.isRequired,
    a1c: PropTypes.string.isRequired,
    blood_pressure: PropTypes.string.isRequired,
    total_cholesterol: PropTypes.string.isRequired,
    ldl_cholesterol: PropTypes.string.isRequired,
    hdl_cholesterol: PropTypes.string.isRequired,
    triglycerides: PropTypes.string.isRequired,
    fasting_glucose: PropTypes.string.isRequired,
    smoking_attestation: PropTypes.string.isRequired
  }

  get employee_id() {
    return this._employee_id
  }

  get form_attachment() {
    return this._form_attachment
  }

  get patient_name() {
    return this._patient_name
  }

  get screen_date() {
    return this._screen_date
  }

  get height() {
    return this._height
  }

  get weight() {
    return this._weight
  }

  get body_mass_index() {
    return this._body_mass_index
  }

  get a1c() {
    return this._a1c
  }

  get blood_pressure() {
    return this._blood_pressure
  }

  get total_cholesterol() {
    return this._total_cholesterol
  }

  get ldl_cholesterol() {
    return this._ldl_cholesterol
  }

  get hdl_cholesterol() {
    return this._hdl_cholesterol
  }

  get triglycerides() {
    return this._triglycerides
  }

  get fasting_glucose() {
    return this._fasting_glucose
  }

  get smoking_attestation() {
    return this._smoking_attestation
  }
}

export default SeldonBeattieForm
